import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

// Static reference to track the popup window
let popupWindow = null;

function FocusWindow({
  children,
  title = "WardBord Evaluation",
  /** Initial outer window size (users can still resize). */
  width = 900,
  height = 500,
  /** Minimum width for document content (horizontal scroll if window is narrower). */
  minWidth = 600,
  onClose,
}) {
  const [containerEl, setContainerEl] = useState(null);
  const newWindowRef = useRef(null);

  const openPopup = () => {
    if (popupWindow && !popupWindow.closed) {
      popupWindow.focus();
      return;
    }

    const sw = window.screen?.availWidth ?? 1920;
    const sh = window.screen?.availHeight ?? 1080;
    const w = Math.min(width, sw - 48);
    const h = Math.min(height, sh - 48);
    const left = Math.max(24, Math.floor((sw - w) / 2));
    const top = Math.max(24, Math.floor((sh - h) / 2));

    popupWindow = window.open(
      "",
      title,
      `width=${w},height=${h},left=${left},top=${top},location=no,menubar=no,toolbar=no,resizable=yes,scrollbars=yes`,
    );
    newWindowRef.current = popupWindow;

    const container = popupWindow.document.createElement("div");
    container.id = "wardbord-eval-popout-root";
    container.style.width = "100%";
    container.style.minWidth = `${minWidth}px`;
    container.style.boxSizing = "border-box";
    popupWindow.document.body.appendChild(container);
    setContainerEl(container);

    const styleSheets = Array.from(
      document.querySelectorAll('link[rel="stylesheet"], style'),
    );
    styleSheets.forEach((sheet) => {
      popupWindow.document.head.appendChild(sheet.cloneNode(true));
    });

    popupWindow.document.title = title;
    popupWindow.document.documentElement.style.height = "100%";
    popupWindow.document.body.style.margin = "0";
    popupWindow.document.body.style.width = "100%";
    popupWindow.document.body.style.minWidth = `${minWidth}px`;
    popupWindow.document.body.style.boxSizing = "border-box";
    popupWindow.document.body.style.fontFamily = "Arial, sans-serif";

    const handleBeforeUnload = () => {
      onClose && onClose();
      popupWindow = null;
    };
    popupWindow.addEventListener("beforeunload", handleBeforeUnload);
  };

  const closePopup = () => {
    if (popupWindow && !popupWindow.closed) {
      popupWindow.close();
      popupWindow = null;
      onClose && onClose();
    }
  };

  useEffect(() => {
    openPopup();
  }, [title, width, height, minWidth, onClose]);

  // If container is not ready yet, render nothing
  if (!containerEl) return null;

  // Use React Portal to render children into the container in the new window
  return ReactDOM.createPortal(children, containerEl);
}

export default FocusWindow;
